"use strict";

var S3files = function () {

  var fileUpload = function(fileInput) {
    var imagePreview = document.querySelector('.upload-preview')
    // var max_file_num = fileInput.getAttribute('data-max-files') || 10

    fileInput.style.display = 'none' // uppy will add its own file input

    var uppy = Uppy.Core({
      id: fileInput.id,
      autoProceed: fileInput.getAttribute('data-multiple-upload'),
      allowMultipleUploads: fileInput.getAttribute('data-auto-process'),
      //locale: tr,
      restrictions: {
        maxFileSize: 15*1024*1024,
        maxNumberOfFiles: 10,
        minNumberOfFiles: null,
        allowedFileTypes: ['image/*','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.ms-excel','application/x-ole-storage','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/xml','text/xml','text/rtf','application/rtf','application/x-rtf','text/richtext','application/x-soffice','application/x-binary','message/rfc822','application/octet-stream','text/plain','application/vnd.ms-outlook']
      }
    });
  
    uppy.use(Uppy.Dashboard, {
      inline: true,
      target: '#uppy_dashboard',
      replaceTargetContent: false,
      showProgressDetails: true,
      width: 400,
      height: 200,
      
    })
    .use(Uppy.Informer, {
      target: fileInput.parentNode,
    })
    .use(Uppy.ProgressBar, {
      target: '#uppy_dashboard',  //imagePreview.parentNode,
    })
    .use(Uppy.ThumbnailGenerator, {
      thumbnailWidth: 400,
    })

    uppy.use(Uppy.AwsS3, {
      companionUrl: '/', // will call Shrine's presign endpoint on `/s3/params`
    })

    uppy.on('upload-success', function (file, response) {
      // construct uploaded file data in the format that Shrine expects
      var uploadedFileData = JSON.stringify({
        id: file.meta['key'].match(/^cache\/(.+)/)[1], // object key without prefix
        storage: 'cache',
        metadata: {
          size:      file.size,
          filename:  file.name,
          mime_type: file.type,
        }
      })
      if (fileInput.getAttribute('data-auto-process') === 'true') {
        $.ajax({
          url: '/s3files',
          type: "POST",
          beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
          dataType: "script",
          data: {
            s3file: {
              file: uploadedFileData,
              group_id: $('#s3file_group_id').val(),
              email_id: $('#s3file_email_id').val(),
              parent_id: $('#s3file_parent_id').val(),
              parent_type: $('#s3file_parent_type').val(),
              file_class: $('#s3file_file_class').val()
            }
          },
          // s3files/create.js.erb is running, so we do not need the code below
          // success: function(response) {
          //   var s3files_ids_arr = document.getElementsByClassName("s3files_ids")[0];
          //   if (typeof s3files_ids_arr !== typeof undefined) {
          //     var existing_s3files_ids = s3files_ids_arr.value.split(",");
          //     existing_s3files_ids.push(response.data('id'));
          //     s3files_ids_arr.value = existing_s3files_ids.join(",");
          //   }
          // }
        });
      }
      // set hidden field value to the uploaded file data so that it's submitted with the form as the attachment
      // var hiddenInput = fileInput.parentNode.querySelector('.upload-hidden')
      var hiddenInput   = document.querySelector('.upload-hidden');
      hiddenInput.value = uploadedFileData;
    })

    uppy.on('thumbnail:generated', function (file, preview) {
      imagePreview.src = preview
    })

    // uppy.on('complete', function() {
    //   setTimeout(function (){
    //     $.ajax({
    //       url: '/s3files',
    //       type: "GET",
    //       dataType: "script",
    //       data: {
    //         parent_id: $('#s3file_parent_id').val(),
    //         parent_type: $('#s3file_parent_type').val()
    //       },
    //     });
    //   }, 2000);
    // })

    fileInput.setAttribute('data-uppy-activated', 'o');

    return uppy;
  };

  return {
    init: function () {
      document.querySelectorAll('.upload-file').forEach(function (fileInput) {
        if (!fileInput.hasAttribute('data-uppy-activated')) {
          fileInput.setAttribute('data-uppy-activated', 'x');
        }
        if (fileInput.getAttribute('data-uppy-activated') === 'x') {
          fileUpload(fileInput);
        }
      });
    }
  };

}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = S3files;
}
